import React from 'react';

/**
 * Placeholder for a status filter card. Master had `BuyerOptionFilterStatus.tsx`
 * but never rendered it; v2 doesn't surface 'Reviewed' status either. Kept here
 * as a scaffolded slot so future v2 work can light it up without touching the
 * sidebar layout. Renders nothing today.
 */
export const StatusFilter: React.FC = () => {
    return <div hidden aria-hidden="true" />;
};
